import { render } from "./AppFolderModal.vue?vue&type=template&id=0474d660&scoped=true&ts=true"
import script from "./AppFolderModal.vue?vue&type=script&lang=ts"
export * from "./AppFolderModal.vue?vue&type=script&lang=ts"

import "./AppFolderModal.vue?vue&type=style&index=0&id=0474d660&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0474d660"]])

export default __exports__